'use strict';

import {addClass, addCustomEventListener, hasClass, removeClass} from './helpers';

export const customSelect = (() => {
  const selectClass = 'custom-select';
  const openedClass = 'is-opened';
  const activeClass = 'is-active';
  const hiddenClass = 'is-hidden';
  const noneClass = 'is-none';
  const dataInit = 'initialized';
  let _allSelects = null;
  let regexp = /^(https?:\/\/)?|(\/\/)?([\w-]{1,32}\.[\w-]{1,32})[^\s@]*$/gm;
  let listenersInit = false;

  const eventListeners = () => {
    if (!listenersInit) {
      listenersInit = true;
      addCustomEventListener('[data-select-parent] select', 'change', function (e) {
        watchSelect(e.target);
        window.shApp.barba.go(e.target.value);
      });
      // addCustomEventListener('[data-select-item]', 'click', function (e) {
      //   const _el = e.target;
      //   const _prnt = _el.closest('[data-select-parent]');
      //
      //   setSelectValue(_prnt.querySelector('select'), _el.dataset['selectItem']);
      //   removeClass(_prnt, openedClass);
      // });
      document.querySelector('body').addEventListener('click', function (evt) {
        document.querySelectorAll('[data-select-parent]').forEach(_prnt => {
          let targetElement = evt.target;
          const _head = _prnt.querySelector('[data-select-head]');
          let needClose = true;
          while (targetElement != null) {
            if (targetElement.matches('[data-select-head]') && targetElement === _head) {
              if (hasClass(_prnt, openedClass)) removeClass(_prnt, openedClass); else addClass(_prnt, openedClass);
              return;
            } else if (targetElement.matches('[data-select-parent]') && targetElement === _prnt) {
              needClose = false;
              return;
            }
            if (needClose) {
              removeClass(_prnt, openedClass);
            }
            targetElement = targetElement.parentElement;
          }
        });
      }, true);
    }
  };

  function Event(event, params) {
    params = params || {bubbles: false, cancelable: false, detail: undefined};
    const evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  const setSelectValue = (_select, value) => {
    const options = [..._select.options];
    options.forEach((opt, i) => {
      if (opt.value === value) {
        _select.selectedIndex = i;
      }
    });
    _select.dispatchEvent(new Event('change'));
  };

  const watchSelect = (_select) => {
    const _prnt = _select.closest('[data-select-parent]');
    const options = [..._select.options];
    let headTitle = '';
    options.forEach((opt, i) => {
      if (opt.value === _select.value) {
        _select.selectedIndex = i;
        headTitle = opt.innerText;
      }
    });
    removeClass(_prnt.querySelectorAll(`[data-select-item]`), activeClass + ' ' + hiddenClass);
    addClass(_prnt.querySelector(`[data-select-item="${_select.value}"]`), activeClass);
    _prnt.querySelector('[data-select-head]').outerHTML = getSelectHead(_select, headTitle);
  };

  const getSelectHead = (_select, title) => {
    return `<div class="${selectClass}__head ${_select.dataset.className}" data-select-head>${title}</div>`;
  };

  const initSelect = (_select) => {
    const _wrapper = document.createElement('div'); // new wrapper element for select
    let listHtml = '';
    let headTitle = '';

    // create html for custom-select
    _select.querySelectorAll('option').forEach(option => {
      const value = option.getAttribute('value');
      const text = option.innerText;
      let itemClass = `${selectClass}__item`;
      if (value === 'none') {
        itemClass += ` ${noneClass}`;
      }
      if (_select.value === value) {
        itemClass += ` ${activeClass}`;
        headTitle = text;
      }

      if (!!value.match(regexp)[1]) {
        listHtml += `<a href="${value}" class="${itemClass}" data-select-item="${value}">${text}</a>`;
      } else {
        listHtml += `<span class="${itemClass}" data-select-item="${value}">${text}</span>`;
      }
    });
    _select.setAttribute('data-class-name', _select.className);
    // add html for list of items and wrapper
    _wrapper.innerHTML = `${getSelectHead(_select, headTitle)}` +
      `<div class="${selectClass}__content" data-select-content><div class="${selectClass}__list">${listHtml}</div></div>`;
    // insert custom-select element before default-select
    _select.parentNode.insertBefore(_wrapper, _select);
    // remove classAttribute from select
    _select.removeAttribute('class');
    // remove classAttribute from select
    _select.dataset['select'] = dataInit;
    // move default-select in wrapper
    _wrapper.appendChild(_select);
    // add custom-select class for wrapper
    addClass(_wrapper, selectClass);
    // add custom-select attribute for wrapper
    _wrapper.setAttribute('data-select-parent', '');
  };

  const reInit = () => {
    document.querySelectorAll(`[data-select]:not([data-select="${dataInit}"])`).forEach(_select => {
      initSelect(_select);
    });

    setTimeout(() => {
      eventListeners();
    }, 50);
  };

  const init = () => {
    _allSelects = document.querySelectorAll('[data-select]');
    if (_allSelects.length > 0) {
      _allSelects.forEach(_select => {
        initSelect(_select);
      });
      setTimeout(() => {
        eventListeners();
      }, 50);
    }
    window.shApp.selects = {
      reInit
    };
  };

  return {
    init
  };
})();
